import React from "react";
import { NavLink } from "react-router-dom";
import { Compass, LayoutGrid, Clock, Sparkles, Settings } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ITEMS = [
  { to: "/today", key: "nav.today", Icon: Compass, id: "today" },
  { to: "/dashboard", key: "nav.dashboard", Icon: LayoutGrid, id: "dashboard" },
  { to: "/history", key: "nav.history", Icon: Clock, id: "history" },
  { to: "/reflection", key: "nav.reflection", Icon: Sparkles, id: "reflection" },
  { to: "/settings", key: "nav.settings", Icon: Settings, id: "settings" },
];

export function BottomNav() {
  const { t } = useI18n();

  return (
    <nav
      data-testid="bottom-nav"
      aria-label="Primary"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-[440px]"
    >
      <div
        className="dc-card flex items-center justify-between px-2 py-2"
        style={{ borderRadius: 22 }}
        role="tablist"
      >
        {ITEMS.map(({ to, key, Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${id}`}
            aria-label={t(key)}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-1 py-2 rounded-2xl transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F4C95D] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0F172A] ${
                isActive
                  ? "text-[#F4C95D] bg-white/[0.04]"
                  : "text-white/55 hover:text-white/85"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={20}
                  strokeWidth={isActive ? 2 : 1.6}
                  aria-hidden="true"
                />
                <span
                  className="text-[10px] tracking-wide"
                  style={{ letterSpacing: "0.02em" }}
                >
                  {t(key)}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
